import {
  PROFILE_ERROR, EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE, RESET_PROFILE_FLAG,
  GET_PROFILE_DETAIL_SUCCESS, GET_PROFILE_DETAIL,
  GET_PROFILE, GET_PROFILE_SUCCESS
} from "./actionTypes"

export const getProfile = (history) => {
  return {
    type: GET_PROFILE,
    payload: { history }
  }
}

export const getProfileSuccess = (user) => {
  return {
    type: GET_PROFILE_SUCCESS,
    payload: user,
  }
}

export const editProfile = user => {
  return {
    type: EDIT_PROFILE,
    payload: { user },
  }
}

export const profileSuccess = msg => {
  return {
    type: EDIT_PROFILE_SUCCESS,
    payload: msg,
  }
}

export const profileError = error => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  }
}

export const resetProfileFlag = error => {
  return {
    type: RESET_PROFILE_FLAG,
  }
}

export const getProfileDetail = () => {
  return {
    type: GET_PROFILE_DETAIL,
  }
}

export const getProfileDetailSuccess = (user) => {
  return {
    type: GET_PROFILE_DETAIL_SUCCESS,
    payload: user,
  }
}
